// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("./role.res.js");
var RoleCreate$ReactHooksTemplate = require("./RoleCreate.res.js");

function reducer(param, action) {
  if (typeof action !== "object") {
    return "InvalidRole";
  } else {
    return {
            TAG: "Available",
            _0: action._0
          };
  }
}

function fetchRole(id) {
  var url = "/api/v1/roles/" + id;
  return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                return Json_decode.field("role", Role$ReactHooksTemplate.decode, param);
              }));
}

function RoleEdit(props) {
  var id = props.id;
  var match = React.useReducer(reducer, "FetchingRoles");
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (role) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchedRole",
                                  _0: role
                                }));
                }), fetchRole(id));
        }), []);
  if (typeof state !== "object") {
    if (state === "FetchingRoles") {
      return JsxRuntime.jsx("p", {
                  children: "Loading roles"
                });
    } else {
      return JsxRuntime.jsx("p", {
                  children: "Role not found"
                });
    }
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(RoleCreate$ReactHooksTemplate.make, {
                      role: Caml_option.some(state._0)
                    })
              });
  }
}

var make = RoleEdit;

exports.reducer = reducer;
exports.fetchRole = fetchRole;
exports.make = make;
/* react Not a pure module */
